import { styled } from "@mui/material/styles";
import { default as MuiAppBar } from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

export const AppBar = styled(MuiAppBar)(({ theme }) =>
    theme.unstable_sx({
        position: { md: "static", xs: "sticky" },
        zIndex: { md: 0, xs: theme.zIndex.drawer },
        boxShadow: theme.customShadows.far,
        backgroundColor: "white.main",
    }),
);

export const HeaderContainer = styled(Container)(({ theme }) =>
    theme.unstable_sx({
        px: 4,
    }),
);

export const HeaderToolbar = styled(Toolbar)(({ theme }) =>
    theme.unstable_sx({
        justifyContent: "space-between",
        height: "80px",
        px: { xs: 0 },
    }),
);

export const LogoBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        cursor: "pointer",
        lineHeight: 0,
    }),
);

export const DesktopNavBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        display: { md: "block", xs: "none" },
        flexGrow: 0,
    }),
);

export const NavTabs = styled(Tabs)(({ theme }) =>
    theme.unstable_sx({
        ".MuiTabs-flexContainer": {
            justifyContent: "space-evenly",
            width: "100%",
        },
        ".MuiTabs-indicator": {
            backgroundColor: "primary.main",
            bottom: 0,
            top: "unset",
        },
        color: "grey.800",
    }),
);

export const NavTab = styled(Tab)(({ theme }) =>
    theme.unstable_sx({
        width: "25%",
        minWidth: "100px",
        maxWidth: "94px",
        height: "80px",
        minHeight: 0,
        padding: 2,
        textTransform: "none",
        fontSize: "1.2rem",
        color: "grey.800",
        "&.Mui-selected": {
            color: "primary.main",
        },
    }),
);

export const MobileSpacer = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        display: { md: "none" },
        flexGrow: 1,
    }),
);

export const LogoutButton = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        gap: 1,
        border: "none",
        padding: "5px 8px",
        fontWeight: 400,
        color: "grey.800",
        backgroundColor: "transparent",
        fontFamily: "NNNittiGroteskTextRegular",
        fontSize: "1.6rem",
        pr: 0,
        "&:hover": { background: "none" },
    }),
);

export const NavIconDefault = styled(Stack)({
    "& svg": { width: "2.1rem", height: "2.1rem" },
});

export const NavIconSmall = styled(Stack)({
    "& svg": { width: "1.8rem", height: "2.1rem" },
});

export const NavIconLarge = styled(Stack)({
    "& svg": { width: "2.4rem", height: "2.4rem" },
});

export const NavIconWide = styled(Stack)({
    "& svg": { width: "2.4rem", height: "1.8rem" },
});

export const LogoWrapper = styled(Box)({
    display: "flex",
    "& svg": { width: 61, height: 34 },
});

export const LogOutIconWrapper = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        mr: "4px",
        "& svg": { width: "1.6rem", height: "2.1rem" },
    }),
);
